import Vue from 'vue';
import Toasted from 'vue-toasted';
import VuejsDialog from 'vuejs-dialog';
import VueAnalytics from 'vue-analytics';
import FontAwesomeIcon from './helpers/icons';
import App from './App.vue';
import router from './router';
import store from './store/index';
import './registerServiceWorker';
import 'vuejs-dialog/dist/vuejs-dialog.min.css';
import i18n from './i18n';
import ButtonLoading from '@/components/buttons/Loading';
import Axios from '@/plugins/axios';
import Message from '@/plugins/message';
import Tabs from '@/plugins/tabs';
import User from '@/plugins/user';

// Plugins
Vue.use(Axios);
Vue.use(Message);
Vue.use(Tabs);
Vue.use(User);

// Analytics
Vue.use(VueAnalytics, {
  id: 'UA-90710923-15',
  router,
});

// Font Awesome
Vue.component('font-awesome-icon', FontAwesomeIcon);

// Button: Loading
Vue.component('button-loading', ButtonLoading);

// vue-toasted
Vue.use(Toasted, {
  position: 'top-right',
  duration: 3000,
});

// vuejs-dialog
Vue.use(VuejsDialog);

Vue.config.productionTip = false;

// Vue-mixins
Vue.mixin({
  computed: {
    routeIdentifier() {
      const type =
        this.$route && this.$route.params
          ? JSON.stringify(this.$route.params)
          : 'general';
      return `route-${type}`;
    },
  },
  methods: {
    componentExists(componentName) {
      return typeof this.$options.components[componentName] !== 'undefined';
    },
    decouple(input) {
      return JSON.parse(JSON.stringify(input));
    },
    find({ object, type, id, callback }) {
      this.$store.dispatch(`${object}/get`, {
        type: type,
        callback: entries => {
          const entry = entries.find(item => item._id === id);
          if (typeof callback === 'function' && typeof entry !== 'undefined') {
            callback(entry && entry.body ? entry.body : entry);
          }
        },
      });
    },
    findBy({ object, type, id, callback, error, field }) {
      let whereField = '_id';
      if (typeof field !== 'undefined') {
        whereField = field;
      }
      this.$store.dispatch(`${object}/get`, {
        type: type,
        callback: entries => {
          const entry = entries.find(
            item =>
              item.body[whereField] === id && item.body.object_type === type,
          );
          if (typeof callback === 'function' && typeof entry !== 'undefined') {
            callback(entry && entry.body ? entry.body : entry);
          }
          if (typeof error === 'function' && typeof entry === 'undefined') {
            error();
          }
        },
      });
    },
    doMenuFormat(data) {
      const input = JSON.parse(JSON.stringify(data));
      const result = input.map(function(item) {
        if (item.icon.indexOf(',') !== -1) {
          item.icon = item.icon.split(',');
        }
        if (item.params && Array.isArray(item.params)) {
          const repeaterParams = JSON.parse(JSON.stringify(item.params));
          item.params = {};
          if (typeof repeaterParams.forEach === 'function') {
            repeaterParams.forEach(param => {
              item.params[param.key] = param.value;
            });
          }
        }
        return item;
      });
      if (result.length === 0) {
        return [];
      }
      return [
        {
          label: 'Sidebar',
          items: result,
        },
      ];
    },
  },
});

// Auth routes
router.beforeEach((to, from, next) => {
  store
    .dispatch('auth/CHECK_TOKEN')
    .then(() => {
      if (
        to.matched.some(record => record.meta.requiresAuth) &&
        !store.getters['auth/isLogged']
      ) {
        next({
          path: '/login',
          query: {
            redirect: to.fullPath,
          },
        });
      } else if (
        to.matched.some(record => record.meta.permissions) &&
        !store.getters['auth/hasPermissions'](to.meta.permissions)
      ) {
        next({
          path: '/permissions',
          query: {
            redirect: to.fullPath,
          },
        });
      } else {
        next();
      }
    })
    .catch(() => {
      if (
        to.matched.some(record => record.meta.requiresAuth) &&
        !store.getters['auth/isLogged']
      ) {
        next({
          path: '/login',
          query: {
            redirect: to.fullPath,
          },
        });
      } else {
        next();
      }
    });
});

// Vue
new Vue({
  router,
  store,
  i18n,
  render: h => h(App),
}).$mount('#app');
